import { isEmpty } from 'lodash';
import validator from "validator";

export type AdminAccountInfo = {
  _id: string;
  email: string;
  name: string;
  phone: string;
  role: string;
  isActive: boolean;
};

export type ChangeAccountPassword = {
  email: string;
  old_password: string;
  new_password: string;
  confirm_password: string;
}

export const validateChangePassword = ({
  email,
  old_password,
  new_password,
  confirm_password,
}: ChangeAccountPassword) => {
  let errors: any = {};
  
  if (isEmpty(email)) {
    errors.category = "Email wajib diisi";
  };
  
  if (isEmpty(old_password)) {
    errors.oldPassword = "Password lama wajib diisi";
  };

  if (isEmpty(new_password)) {
    errors.newPassword = "Password baru wajib diisi";
  };

  if (isEmpty(confirm_password)) {
    errors.confirmNewPassword = "Masukkan password baru";
  };

  if (new_password !== confirm_password) {
    errors.confirmNewPassword = "Password tidak sesuai";
  };

  return {
    errors,
    isValid: isEmpty(errors),
  };
};

export const validateAccountInfo = ({
  name,
  email,
  phone,
  role,
}: AdminAccountInfo) => {
  let errors: any = {};

  if (isEmpty(name)) {
    errors.name = "Nama wajib diisi";
  };

  if (isEmpty(email)) {
    errors.email = "Email wajib diisi";
  } else {
    if(!validator.isEmail(email)) {
      errors.email = "Email tidak valid"
    }
  };

  if (isEmpty(phone)) {
    errors.phone = "No. HP wajib diisi";
  };

  if (isEmpty(role)) {
    errors.role = "Jabatan wajib dipilih";
  };

  return {
    errors,
    isValid: isEmpty(errors),
  };
};